import React, { useState, useEffect } from 'react';
import { saveUserToFirestore, saveUserToLocalStorage, getUserFromFirestore } from '../../userService';
import UserProfileForm from './UserProfileForm';
import { useAuth } from '../../contexts/AuthContext';

const UserProfile = () => {
    const { user, logout } = useAuth();

    const [userData, setUserData] = useState({
        name: '',
        jobTitle: '',
        address: '',
        phoneNumber: '',
        email: '',
        invoiceNumber: 0
    });

    useEffect(() => {
        const fetchUserData = async (email) => {
            const user = await getUserFromFirestore(email);
            if (user) {
                setUserData(user);
            }
        };

        if (user) {
            const email = user.email;
            fetchUserData(email);
        } else {
            console.log('No user is signed in.');
            logout();
        }
    }, [user, logout]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData({ ...userData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await saveUserToFirestore(userData);
        saveUserToLocalStorage(userData);
        alert('Informations sauvegardées avec succès!');
    };

    return <UserProfileForm userData={userData} handleChange={handleChange} handleSubmit={handleSubmit} />
};

export default UserProfile;